import { Badge, Flex, Text, Tooltip } from '@radix-ui/themes'

import React from 'react'
import { MdBusiness } from '@react-icons/all-files/md/MdBusiness'
import type { Group } from 'types/group'
import { getSharedChannelBusinessRecipients } from '../utils'
type Props = {
  channel: Group
}
const NUM_TO_SHOW = 2

const ShareChannelSubheader = ({ channel }: Props): React.ReactNode => {
  if (!channel) return null
  const businessRole = channel.business_role
  const sharedBusinesses = channel.shared_with_businesses
  const channelOwnersSharedBusinesses =
    businessRole === 'owner' &&
    sharedBusinesses &&
    getSharedChannelBusinessRecipients(sharedBusinesses)
  const channelPartnerSharedBusiness =
    channel && businessRole === 'partner' && channel.business?.name
  if (!channelOwnersSharedBusinesses && !channelPartnerSharedBusiness)
    return null
  const initialBusinessList =
    channelOwnersSharedBusinesses &&
    channelOwnersSharedBusinesses?.slice(0, NUM_TO_SHOW)
  const toolTipBusinessList =
    channelOwnersSharedBusinesses &&
    channelOwnersSharedBusinesses?.slice(NUM_TO_SHOW)
  const label = channelPartnerSharedBusiness
    ? `Shared by ${channelPartnerSharedBusiness.toString()}`
    : initialBusinessList
    ? `Shared with ${initialBusinessList?.join(', ')}`
    : null
  return (
    <Flex align="center" gap="1">
      <MdBusiness color="#777777" size={12} />
      <Text size="1">{label}</Text>
      {toolTipBusinessList && toolTipBusinessList?.length > 0 && (
        <Tooltip
          maxWidth="120px"
          side="bottom"
          content={toolTipBusinessList?.map((business, index, array) => (
            <div key={index}>
              {business}
              {index < array.length - 1 && <span>,</span>}
            </div>
          ))}
        >
          <Badge size="1" color="gray" radius="small">
            {`+${toolTipBusinessList?.length}`}
          </Badge>
        </Tooltip>
      )}
    </Flex>
  )
}

export default ShareChannelSubheader
